import React, { useState, useEffect } from "react"
import intl from "react-intl-universal"
import { useForm } from "react-hook-form"
import { Flex } from "@stardust-ds/react"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"

import ModalComponent from "../../../../components/ModalComponent"
import RcmpTextArea from "../../../../../../atoms/TextArea"
import Button from "../../../../../../atoms/Button"
import { ModalInformation } from "../../../../components/ModalInformation"

const validateOnlySpaces = (value) => {
  return Boolean(value === "" || /\S/.test(value))
}

const schema = yup.object().shape({
  cobservation: yup
    .string()
    .notRequired()
    .test(
      "validateOnlySpaces",
      "ciq.launch_observation.errors.not_allowed_only_space",
      validateOnlySpaces,
    ),
})

const ModalObservation = ({ bIsOpen, oLaunch, onClose, onConfirm, onSubmit, bIsLoading }) => {
  const [bIsOpenCancelModal, setBIsOpenCancelModal] = useState(false)
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (!oLaunch?.cobservation) return

    setValue("cobservation", oLaunch.cobservation)
  }, [oLaunch])

  const onCloseModal = () => {
    if (bIsLoading) return

    if (isDirty) {
      setBIsOpenCancelModal(true)
      return
    }

    onClose?.()
    reset()
  }

  const onCloseModalAnyway = () => {
    setBIsOpenCancelModal(false)
    onClose?.()
    reset()
  }

  const onConfirmObservation = async (data, e) => {
    e.preventDefault()
    e.stopPropagation()

    if (bIsLoading) return

    const { cobservation } = data
    
    const oBody = { ...oLaunch, cobservation }

    if (typeof onSubmit === "function") {
      return await onSubmit(oBody)
    }

    onConfirm?.(oBody)

    onCloseModalAnyway()
  }

  if (!bIsOpen) return null

  return (
    <>
      <ModalComponent
        title={intl.get("ciq.launch_observation.title")}
        fnCloseModal={onCloseModal}
        size="lg"
      >
        <form onSubmit={handleSubmit(onConfirmObservation)}>
          <Flex
            width="100%"
            flexDirection="column"
            style={{ marginBottom: -32 }}
            gap="15px"
          >
            <RcmpTextArea
              label={intl.get("ciq.launch_observation.label")}
              placeholder={intl.get("ciq.type_here")}
              minHeight={230}
              height={"auto"}
              fullHeight={false}
              {...register("cobservation")}
              hasError={!!errors?.cobservation}
              helperText={intl.get(`${errors?.cobservation?.message}`)}
              style={{ resize: "vertical" }}
            />
            <Flex
              width="100%"
              alignItems="center"
              justifyContent="space-between"
              gap="8px"
            >
              <Button
                type="button"
                variant="outline"
                liquid={true}
                onClick={onCloseModal}
                disabled={bIsLoading}
              >
                {intl.get("cap_close")}
              </Button>
              <Button isLoading={bIsLoading} disabled={bIsLoading} type="submit">{intl.get("ciq.launch_observation.save")}</Button>
            </Flex>
          </Flex>
        </form>
      </ModalComponent>
      {bIsOpenCancelModal && (
        <ModalInformation
          title={intl.get("ciq.launch_observation.title")}
          description={intl.get("ciq.changes_not_save")}
          onClose={onCloseModalAnyway}
          onCancel={() => setBIsOpenCancelModal(false)}
        />
      )}
    </>
  )
}

export default ModalObservation
